/**
 * ApartmentSearchService.
 * Tämän servicen tehtävä on ottaa vastaan pallo hakuehtoja, muokata
 * ne API:lle sopivaan formaattiin, suorittaa kysely ja tallentaa vastaus.
 */
app.factory("ApartmentSearchService",
	["$http", "$timeout", "$rootScope", "$injector", "GeoService", "BrowserStorageService", function($http, $timeout, $rootScope, $injector, GeoService, BrowserStorageService) {

		var ApartmentSearchModel;

		var self = this;
		var service = this;
		var initialized = false;
		var queryListeners = {};
		var preQueryListeners = {};
		var notificationListeners = {};
		var redirectSearch = false;

		/**
		 * Lista käytettävissä olevista sorttausvaihtoehdoista.
		 * @type {{id: string, name: string}[]}
		 */
		var availableSortParams = [
			{
				id: 'nearest',
				name: 'Lähimmät ensin',
				order: undefined
			},
			{
				id: 'salesPriceUnencumbered',
				name: 'Hinnan mukaan',
				order: 'asc'
			},
			{
				id: 'sortArea',
				name: 'Neliöiden mukaan',
				order: 'asc'
			},
			{
				id: 'latestPublishTimestamp',
				name: 'Uusimmat',
				order: 'desc'
			}
		];

		/**
		 * Utility-funktio extended constraintin hakemiseen sisäisen ID:n perusteella.
		 * @param internalId
		 * @returns {*}
		 */
		function GetExtendedConstraint(internalId, root) {
			if(root === undefined) {
				root = availableExtendedConstraints;
			}
			for(var i = 0; i < root.length; i++) {
				if(root[i].internalId == internalId) {
					return root[i];
				}
				if(root[i].type == 'multitype') {
					var constraint = GetExtendedConstraint(internalId, root[i].data);
					if(typeof(constraint) != 'undefined') {
						return constraint;
					}
				}
			}
			return undefined;
		}

		// ---------------------------------------------------------------------------------------------------------------------------------------------------------
		// Query-object
		// ---------------------------------------------------------------------------------------------------------------------------------------------------------
		/**
		 * Standardimuoto queryille.
		 * Mikäli täytyy tehdä apartment-haku jostain, hae tämä aihio
		 * CreateQuery():llä, täytä se ja viskaa takaisin.
		 *
		 * Sisältää getterit ja setterit helppoa käyttöä varten. Niiden käyttö on suotavaa,
		 * jopa suositeltavaa. Getterien kautta _voi_ asettaa arvoja, ei tosin suositeltava tapa,
		 * koska settaukseen voi liittyä muutakin kuin assignaus. Setterit
		 * tekevät asettamisen aina taatusti oikein.
		 *
		 * standardConstraints: sisältää perushaun parametrit (osoite, huonelkm, hinta).
		 * extendedConstraints: sisältää mahdollisia lisähakuparametrejä, jotka on määritelty yllä
		 * availableExtendedConstraints:ssa.
		 *
		 * Lisäksi on vielä käyttäjälle näkymättömiä parametrejä, kuten geolocation, radius, jne.
		 * jotka voi asettaa settereillä. Kaikki on dokumentoitu alla.
		 */
		var QueryObject = function() {

			var queryVersion = 7;

			/**
			 * Hintakattoa vastaava arvo, tätä käytetään mm. slidereissä. Jos max price
			 * on asetettu täksi, oletetaan, että hinnalla ei ole mitään kattoa.
			 * @type {number}
			 */
			this.MAXPRICE = 1010000;
			this.MAXRENTALPRICE = 10100;

			/**
			 * Lisähakuparametrit, näistä on lista availableExtendedConstraints:ssa.
			 */
			var extendedConstraints = [];

			/**
			 * Perushakuparametrit, nämä on määritelty aina.
			 * Defaulttiasetukset: ei huonerajoitusta, ei osoitetta, ei hintarajoitetta.
			 * @type {{rooms: boolean[], address: Array, price: {min: number, max: number}}}
			 */
			var standardConstraints = {};

			/**
			 * Geolokaatio, [latitude, longitude]
			 * @type {Array}
			 */
			var geolocation = [];

			/**
			 * Hakuradius geolokaatiosta, metreinä.
			 * @type {number}
			 */
			var radius;

			/**
			 * Sorttausmetodi.
			 * @type {{id: string, name: string}}
			 */
			var sorting = availableSortParams[3];


			/**
			 * Vuokrattavia?
			 * @type {boolean}
			 */
			var rental = false;

			/**
			 * Videoesittelyt?
			 * @type {boolean}
			 */
			var video = false;

			/**
			 * Hakutuloslimitti.
			 * @type {number}
			 */
			var limit = 30;

			/**
			 * Skip (eli offset), eli kuinka monta tulosta skipataan haun tuloksista.
			 * @type {number}
			 */
			var skip = 0;

			/**
			 * Kentät, jotka halutaan saada haussa. Käytetään, jottei haeta turhaa dataa.
			 * @type {Array}
			 */
			var fields = [];

			/**
			 * Latitude/longitude box, karttarajaus hakutuloksille.
			 * @type {{sw: Array, ne: Array}}
			 */
			var box = {
				sw: [],
				ne: []
			};

			/**
			 * Tällä parametrilla haetaan samankaltaisia kohteita, ei sisällä varsinaisia hakutuloksia.
			 * @type {Array}
			 */
			var similar = false;

			/**
			 * Tähän objektiin lisätään key-value-pareina custom-hakuparametrit, jos sellaisia tarvitaan.
			 * @type {Object}
			 */
			var customQueryParams = {};

			this.GetQueryVersion = function() {
				return queryVersion;
			};

			this.GetAsStorageBlob = function() {
				return {
					queryVersion: queryVersion,
					extendedConstraints: extendedConstraints,
					standardConstraints: standardConstraints,
					geolocation: geolocation,
					radius: radius,
					sorting: sorting,
					rental: rental
				};
			};

			this.MergeStorageQueryBlob = function(blob) {
				if(blob && blob.queryVersion == queryVersion) {
					queryVersion = blob.queryVersion;
					extendedConstraints = blob.extendedConstraints;
					standardConstraints = blob.standardConstraints;
					geolocation = blob.geolocation;
					radius = blob.radius;
					sorting = blob.sorting;
					rental = blob.rental;
				}

				return this;
			};

			this.CloneSettingsFromAnotherQuery = function(query) {
				var blob = angular.copy(query.GetAsStorageBlob());
				this.MergeStorageQueryBlob(blob);
			};

			/**
			 * Tuplien tarkastus osoitteille.
			 * @param address
			 * @returns {boolean}
			 * @constructor
			 */
			function IsDupeAddress(address) {
				for(var i = 0; i < standardConstraints.address.length; i++) {
					var a = standardConstraints.address[i];
					if(angular.toJson(address) === angular.toJson(a)) {
						return true;
					}
				}
				return false;
			}

			/**
			 * Tuplien tarkastus kohteille.
			 * @param propertyKey
			 * @returns {boolean}
			 * @constructor
			 */
			function IsDupeProperty(property) {
				for(var i = 0; i < standardConstraints.propertyKey.length; i++) {
					if(property == standardConstraints.propertyKey[i]) {
						return true;
					}
				}
				return false;
			}

			this.clearStandardConstraints = function() {
				standardConstraints = {
					rooms: [
						false,
						false,
						false,
						false,
						false
					],
					address: [],
					price: {
						min: '',
						max: ''
					},
					rentalPrice: {
						min: '',
						max: ''
					},
					groupType: [
						{mapping: 'kerrostaloasunnot', selected: false, name: 'Kerros-/luhtitalo'},
						{mapping: 'rivitalot-paritalot', selected: false, name: 'Rivitalo/paritalo'},
						{mapping: 'omakotitalot', selected: false, name: 'Omakoti-/erillistalo'},
						{mapping: 'maatilat-metsatilat', selected: false, name: 'Maa- tai metsätila'},
						{mapping: 'tontit', selected: false, name: 'Tontti'},
						{mapping: 'vapaa-ajan_asunnot', selected: false, name: 'Vapaa-ajan asunto'},
						{mapping: 'toimitilat', selected: false, name: 'Toimitila'},
						{mapping: 'autotallit', selected: false, name: 'Autotalli'}
					],
					area: {
						min: '',
						max: ''
					},
					newConstruction: [
						{mapping: 'kaikki-kohteet', selected: true, name: 'Kaikki kohteet'},
						{mapping: 'uudiskohteet', selected: false, name: 'Uudiskohteet'},
						{mapping: 'ei-uudiskohteita', selected: false, name: 'Ei uudiskohteita'}
					],
					yearBuilt: {
						min: '',
						max: ''
					},
					condition: [
						{mapping: 'Uusi', selected: false, name: 'Uusi'},
						{mapping: 'Erittäin hyvä', selected: false, name: 'Erittäin hyvä'},
						{mapping: 'Hyvä', selected: false, name: 'Hyvä'},
						{mapping: 'Tyydyttävä', selected: false, name: 'Tyydyttävä'},
						{mapping: 'Huono', selected: false, name: 'Huono'}
					],
					properties: [
						{mapping: 'elevator', selected: false, name: 'Hissi'},
						{mapping: 'seaOrLakeView', selected: false, name: 'Järvi- tai merinäköala'},
						{mapping: 'privateShore', selected: false, name: 'Omaranta'},
						{mapping: 'balcony', selected: false, name: 'Parveke'},
						{mapping: 'sauna', selected: false, name: 'Oma sauna'}
					],
					propertyKey: []
				};
			};
			this.clearStandardConstraints();


			this.ResetToDefaultConstraints = function() {
				rental = false;
				this.clearStandardConstraints();
				extendedConstraints.length = 0;
			};

			this.GetStandardConstraints = function() {
				return standardConstraints;
			};

			// ---------------------------------------------------------------------------------------
			// Lisäconstraintit, joita lisätään hakupalkissa dropareista.
			// ---------------------------------------------------------------------------------------

			this.AddExtendedConstraint = function(extendedConstraint) {
				extendedConstraints.push(extendedConstraint);
			};

			this.RemoveExtendedConstraint = function(internalId) {
				for(var i = 0; i < extendedConstraints.length; i++) {
					if(extendedConstraints[i].internalId == internalId) {
						extendedConstraints.splice(i, 1);
						return;
					}
				}
			};

			this.GetExtendedConstraints = function() {
				return extendedConstraints;
			};

			// ---------------------------------------------------------------------------------------
			// Huonelukumäärät
			// ---------------------------------------------------------------------------------------

			this.SetRoomConstraint = function(roomAmount, constrained) {
				if(roomAmount <= standardConstraints.rooms.length && roomAmount > 0) {
					standardConstraints.rooms[roomAmount-1] = constrained;
				}
			};

			this.GetRoomConstraints = function() {
				return standardConstraints.rooms;
			};

			// ---------------------------------------------------------------------------------------
			// House types
			//---------------------------------------------------------------------------------------
			this.GetHouseTypeConstraints = function() {
				return standardConstraints.groupType;
			};

			// ---------------------------------------------------------------------------------------
			// Area
			//---------------------------------------------------------------------------------------
			this.GetAreaConstraints = function() {
				return standardConstraints.area;
			};

			// ---------------------------------------------------------------------------------------
			// New constructions
			//---------------------------------------------------------------------------------------
			this.GetNewConstructionConstraints = function() {
				return standardConstraints.newConstruction;
			};

			this.SetNewConstructionConstraints = function(item) {
				var newValue = !standardConstraints.newConstruction[item].selected;
				for (var ii in standardConstraints.newConstruction) {
					standardConstraints.newConstruction[ii].selected = false;
				}
				standardConstraints.newConstruction[item].selected = newValue;
				return true;
			};

			// ---------------------------------------------------------------------------------------
			// Year built
			//---------------------------------------------------------------------------------------
			this.GetYearBuiltConstraints = function() {
				return standardConstraints.yearBuilt;
			};

			// ---------------------------------------------------------------------------------------
			// Condition
			//---------------------------------------------------------------------------------------
			this.GetConditionConstraints = function() {
				return standardConstraints.condition;
			};

			// ---------------------------------------------------------------------------------------
			// Properties
			//---------------------------------------------------------------------------------------
			this.GetPropertiesConstraints = function() {
				return standardConstraints.properties;
			};

			// Rental
			this.SetRental = function(r) {
				rental = r;
			};

			this.GetRental = function() {
				return rental;
			};

			// Video
			this.SetVideo = function(r) {
				video = r;
			};

			this.GetVideo = function() {
				return video;
			};

			// ---------------------------------------------------------------------------------------
			// Osoiterajoitteet
			// ---------------------------------------------------------------------------------------

			this.AddAddressConstraint = function(addressConstraint) {
				if(!IsDupeAddress(addressConstraint)) {
					standardConstraints.address.push(addressConstraint);
				}
			};

			this.RemoveAddressConstraint = function(index) {
				standardConstraints.address.splice(index, 1);
			};

			this.GetAddressConstraints = function() {
				return standardConstraints.address;
			};

			// ---------------------------------------------------------------------------------------
			// Kohderajoitteet
			// ---------------------------------------------------------------------------------------

			this.AddPropertyConstraint = function(propertyConstraint) {
				if(!IsDupeProperty(propertyConstraint)) {
					standardConstraints.propertyKey.push(propertyConstraint);
				}
			};

			this.RemovePropertyConstraint = function(index) {
				standardConstraints.propertyKey.splice(index, 1);
			};

			this.GetPropertyConstraints = function() {
				return standardConstraints.propertyKey;
			};

			// ---------------------------------------------------------------------------------------
			// Hintarajoitus
			// ---------------------------------------------------------------------------------------

			this.SetPriceConstraint = function(min, max) {
				standardConstraints.price.min = min;
				standardConstraints.price.max = max;
			};

			this.GetPriceConstraints = function() {
				return standardConstraints.price;
			};

			this.SetRentalPriceConstraint = function(min, max) {
				standardConstraints.rentalPrice.min = min;
				standardConstraints.rentalPrice.max = max;
			};

			this.GetRentalPriceConstraints = function() {
				return standardConstraints.rentalPrice;
			};

			// ---------------------------------------------------------------------------------------
			// Geolocation eli sijaintitieto
			// ---------------------------------------------------------------------------------------

			this.SetGeolocation = function(latitude, longitude) {
				// Geolokaation voi poistaa käytöstä kutsumalla SetGeolocation()
				if(latitude === undefined) {
					geolocation = [];
					radius = undefined;
				}
				else {
					geolocation = [latitude, longitude];
					// Geolokaation ihanuuksia:
					// Kaikenkattava radius on asetettava, tai muuten rajaus rajaa geolokaatiosta
					// kaukana olevat kohteet pois: Joensuussa geolokatoitu haku Helsingin alueelta
					// palauttaa tyhjää, jos radius ei ole tarpeeksi suuri kattamaan Helsinkiä.
					radius = 6371000;
				}
			};

			this.GetGeolocation = function() {
				return geolocation;
			};

			// ---------------------------------------------------------------------------------------
			// Sorttaus
			// Jos sorting on undefinded, ei sitä anneta querylle
			// ---------------------------------------------------------------------------------------

			this.SetSorting = function(sortParam) {
				sorting = sortParam;
			};

			this.GetSorting = function() {
				return sorting;
			};

			// ---------------------------------------------------------------------------------------
			// Limit ja skip
			// ---------------------------------------------------------------------------------------

			this.SetResultLimit = function(count) {
				limit = count;
			};

			this.GetResultLimit = function() {
				return limit;
			};

			this.SetSkip = function(skipCount) {
				skip = skipCount;
			};

			this.GetSkip = function() {
				return skip;
			};

			// ---------------------------------------------------------------------------------------
			// Rajoitetaan haettavaa dataa
			// ---------------------------------------------------------------------------------------

			this.SetDataFields = function(fieldArray) {
				fields = [];
				for(var i = 0; i < fieldArray.length; i++) {
					fields.push(fieldArray[i]);
				}
			};

			this.GetDataFields = function() {
				return fields;
			};

			this.SetSimilar = function(s) {
				similar = s;
			};

			this.GetSimilar = function() {
				return similar;
			};

			// ---------------------------------------------------------------------------------------
			// Aluerajaus latitude/longitude.
			// ---------------------------------------------------------------------------------------

			/**
			 * Asettaa aluerajauksen kahden koordinaattiparin avulla.
			 * Järjestyksellä ei ole väliä.
			 * @param latitude1
			 * @param longitude1
			 * @param latitude2
			 * @param longitude2
			 * @constructor
			 */
			this.SetMapArea = function(latitude1, longitude1, latitude2, longitude2) {
				var east = longitude1 > longitude2 ? longitude1 : longitude2;
				var west = longitude1 < longitude2 ? longitude1 : longitude2;
				var north = latitude1 > latitude2 ? latitude1 : latitude2;
				var south = latitude1 < latitude2 ? latitude1 : latitude2;

				box.ne.length = 0;
				box.ne.push(east);
				box.ne.push(north);
				box.sw.length = 0;
				box.sw.push(west);
				box.sw.push(south);
			};

			this.UnsetMapArea = function() {
				box.ne.length = box.sw.length = 0;
			};

			this.GetMapArea = function() {
				return box;
			};


			/**
			 * Luo finaalimuotoisen query-objektin, joka voidaan syöttää suoraan API-kutsulle
			 * datana. Kootaan kaikki queryn parametrit API:lle sopivaan muotoon.
			 * Jos arvo on default, sitä ei erikseen aseteta.
			 */
			this.GetAsAPIQueryObject = function() {

				var apiQuery = {
					type: 'property',
					limit: limit
				};

				// ---------------------------------------------------------------------------------
				// Default-parametrit
				// ---------------------------------------------------------------------------------

				ParseStandardQueryParameters(apiQuery);

				// ---------------------------------------------------------------------------------
				// Lisäparametrit
				// ---------------------------------------------------------------------------------

				for(var i = 0; i < extendedConstraints.length; i++) {
					ParseConstraint(extendedConstraints[i], apiQuery);
				}

				ParseCustomQueryParameters(apiQuery);

				return apiQuery;
			};

			this.AddCustomQueryParameter = function(key, value) {
				customQueryParams[key] = value;
			};

			this.AddCustomQueryParameters = function(params) {
				for(var key in params) {
					this.AddCustomQueryParameter(key, params[key]);
				}
			};

			/**
			 * Parsee perusparametrit
			 * @param apiQuery {object} - API-query objekti, johon parsitut parametrit sijoitetaan
			 */
			function ParseStandardQueryParameters(apiQuery) {

				// Otetaan tyhjä query oletusarvojen vertailua varten.
				var defaultValues = new QueryObject();

				if(!rental) {
					// min: int, minimihinta (salesPriceUnencumbered)
					if(standardConstraints.price.min != defaultValues.GetPriceConstraints().min) {
						apiQuery.min = standardConstraints.price.min * 1000;
					}

					// max: int, maksimihinta (salesPriceUnencumbered)
					if(standardConstraints.price.max != defaultValues.GetPriceConstraints().max) {
						apiQuery.max = standardConstraints.price.max * 1000;
					}
				} else {
					// min: int, minimivuokra
					if(standardConstraints.rentalPrice.min != defaultValues.GetRentalPriceConstraints().min) {
						apiQuery.min = standardConstraints.rentalPrice.min;
					}

					// max: int, maksimivuokra
					if(standardConstraints.rentalPrice.max != defaultValues.GetRentalPriceConstraints().max) {
						apiQuery.max = standardConstraints.rentalPrice.max;
					}
				}


				// rooms: array of int, huoneiden lukumäärä (roomAmount)
				for(var r = 1; r <= standardConstraints.rooms.length; r++) {
					if(standardConstraints.rooms[r-1]) {
						if(typeof apiQuery['rooms[]'] == 'undefined') {
							apiQuery['rooms[]'] = [];
						}
						apiQuery['rooms[]'].push(r);
					}
				}

				// House types
				for(var h = 0; h < standardConstraints.groupType.length; h++) {
					if(standardConstraints.groupType[h].selected === true) {
						if(typeof apiQuery['groupType[]'] == 'undefined') {
							apiQuery['groupType[]'] = [];
						}
						apiQuery['groupType[]'].push(standardConstraints.groupType[h].mapping);
					}
				}

				// Area size
				if (standardConstraints.area.min !== standardConstraints.area.floor) {
					apiQuery['minArea'] = standardConstraints.area.min;
				}

				if (standardConstraints.area.max !== standardConstraints.area.ceil) {
					apiQuery['maxArea'] = standardConstraints.area.max;
				}

				// Year built
				if (standardConstraints.yearBuilt.min !== standardConstraints.yearBuilt.floor) {
					apiQuery['minYearBuilt'] = standardConstraints.yearBuilt.min;
				}

				if (standardConstraints.yearBuilt.max !== standardConstraints.yearBuilt.ceil) {
					apiQuery['maxYearBuilt'] = standardConstraints.yearBuilt.max;
				}

				// New construction
				if (standardConstraints.newConstruction[1].selected === true) {
					// If use groupType as 'uudiskohteet' then this really doesn't work when user has some other groupType's selected.
					// if(typeof apiQuery['groupType[]'] === 'undefined') {
					// 	apiQuery['groupType[]'] = [];
					// }
					//
					// apiQuery['groupType[]'].push(standardConstraints.newConstruction[1].mapping);
					apiQuery['newConstruction'] = true;
				}

				if (standardConstraints.newConstruction[2].selected === true) {
					apiQuery['newConstruction'] = false;
				}

				// Condition
				for(var c = 0; c < standardConstraints.condition.length; c++) {
					if(standardConstraints.condition[c].selected === true) {
						if(typeof apiQuery['condition[]'] == 'undefined') {
							apiQuery['condition[]'] = [];
						}
						apiQuery['condition[]'].push(standardConstraints.condition[c].mapping);
					}
				}

				// Properties
				for(var p = 0; p < standardConstraints.properties.length; p++) {
					if(standardConstraints.properties[p].selected === true) {
						apiQuery[standardConstraints.properties[p].mapping] = true;
					}
				}

				// Osoitteet / hakualueet
				if(standardConstraints.address.length > 0) {
					apiQuery['query[]'] = [];
					for(var i = 0; i < standardConstraints.address.length; i++) {
						apiQuery['query[]'].push(JSON.stringify(standardConstraints.address[i].query));
					}
				}

				// Kohde id:t, propertyKey(s)
				if (standardConstraints.propertyKey && standardConstraints.propertyKey.length > 0) {
					apiQuery['propertyKey[]'] = standardConstraints.propertyKey;
				}

				// Sorttaus
				// Huom! API ei tunne "nearest" parametriä, vaan tarvitsee vain lat,lonin ja radiuksen
				// jotta tehdään ns. "nearest" haku. Siksi poistettu tässä jos tulee vastaan.
				if(sorting !== undefined && sorting.id != "nearest") {
					apiQuery.sort = sorting.id;

					if (sorting.order !== undefined) {
						apiQuery.sortOrder = sorting.order;
					}
				}

				// Kartta-alueen rajaus
				if(box.sw.length == 2 && box.ne.length == 2) {
					apiQuery.box = JSON.stringify(box);
				}

				// Geolocation, jos on asetettu

				if(geolocation.length == 2 && sorting !== undefined && sorting.id == 'nearest' &&
					box.sw.length === 0) {
					apiQuery.lat = geolocation[0];
					apiQuery.lon = geolocation[1];
					apiQuery.rad = radius;
				}


				// Rental
				if(rental) {
					apiQuery.rental = true;
				}

				// Videoesittely
				if (video) {
					apiQuery.video = true;
				}

				// Skip
				if(skip > 0) {
					apiQuery.skip = skip;
				}

				// Fields
				if(fields.length > 0) {
					var f = {};
					for(var j = 0; j < fields.length; j++) {
						f[fields[j]] = 1;
						apiQuery.fields = JSON.stringify(f);
					}
				}

				if(similar) {
					apiQuery.similar = true;
				}
			}

			/**
			 * Parsii custom parametrit customQueryParams-objektista
			 * ja lisää ne API-querylle.
			 * @param constraintData
			 * @param apiQuery
			 */
			function ParseCustomQueryParameters(apiQuery) {
				for(var key in customQueryParams) {
					apiQuery[key] = customQueryParams[key];
				}
			}

			return this;

		};

		// ---------------------------------------------------------------------------------------------------------------------------------------------------------
		// Servicen toiminnallisuus
		// ---------------------------------------------------------------------------------------------------------------------------------------------------------

		/**
		 * Palauttaa instanssin defaultQuerystä.
		 */
		this.CreateQuery = function() {
			return new QueryObject();
		};

		this.GetAvailableConstraint = function(id) {
			var c =  this.GetStandardConstraints()[id];
			if(c !== undefined) {
				return angular.copy(c);
			}
			else {
				return undefined;
			}
		};

		/**
		 * Palauttaa mahdolliset sort parametrit.
		 */
		this.GetAvailableSortParams = function() {
			return angular.copy(availableSortParams);
		};

		/**
		 * Tekee API-kutsun annetuilla hakuparametreillä
		 * @param sourceQueryObject {QueryObject}
		 * @param identifier {string} - Identifier, jolla hakutulos tallennetaan ApartmentSearchModeliin.
		 * @param appendResults {boolean} - appendataanko ylikirjoittamisen sijaan haettu data annettuun identifieriin.
		 * @param callback {searchQueryCallback}
		 * @param ignorePreQueryCallbacks {boolean} - skipataanko preQueryCallbackit (erikoistapaukset käyttää)
		 * @constructor
		 */
		this.RunQuery = function(sourceQueryObject, identifier, appendResults, callback, ignorePreQueryCallbacks) {

			// If redirectSearch, then we don't want to query api as we aren't even showing results
			if (this.redirectSearch)
			{
				console.log('redirectSearch - No searching!');
				return;
			}

			// Ennenkuin voidaan suorittaa haku, pitää tarkastaa, onko meille asetettu
			// sorttauksessa "lähimmät ensin" - jos on, ennen hakua pitää määrittää oma
			// sijainti GeoServicen avulla. Vasta kun sijainti ollaan saatu, voidaan
			// itse haku suorittaa.
			// Tätä ei tehdä QueryObject.GetAsQPIQueryObject():ssa, koska itse lokaation määritys
			// halutaan tehdä vasta kun koetetaan tehdä itse haku, eikä joka kerta kun
			// query object muutetaan API-ystävälliseen muotoonsa.
			//console.log(sourceQueryObject.GetAsStorageBlob());
			var querySorting = sourceQueryObject.GetSorting();

			if(querySorting !== undefined && querySorting.id == 'nearest') {
				GeoService.RequestPosition(function(coords) {
					if(coords != null) {
						sourceQueryObject.SetGeolocation(coords.latitude, coords.longitude);
					}

					//console.log("Nearest sorting, API query:", sourceQueryObject.GetAsAPIQueryObject());
					RunApiCall(sourceQueryObject, identifier, appendResults, callback, ignorePreQueryCallbacks);
				});
			}
			else {
				//console.log("Other sorting, API query:", sourceQueryObject.GetAsAPIQueryObject());
				RunApiCall(sourceQueryObject, identifier, appendResults, callback, ignorePreQueryCallbacks);
			}



		};

		/**
		 * Lisää query listener.
		 * Query listenerit ajetaan, aina kun query on onnistuneesti tai
		 * epäonnistuneesti suoritettu.
		 * @param resultIdentifier {string} - hakutuloksen identifier, jota halutaan kuunnella
		 * @param callback
		 * @constructor
		 */
		this.AddQueryListener = function(resultIdentifier, callback) {
			if(queryListeners[resultIdentifier] === undefined) {
				queryListeners[resultIdentifier] = [];
			}
			queryListeners[resultIdentifier].push(callback);
		};

		/**
		 * Poista query listener.
		 * @param callback
		 * @constructor
		 */
		this.RemoveQueryListener = function(callback) {
			for(var identifier in queryListeners) {
				for(var i = 0; i < queryListeners[identifier].length; i++) {
					if(queryListeners[identifier][i] == callback) {
						queryListeners[identifier].splice(i, 1);
						return;
					}
				}
			}
		};

		/**
		 * PreQueryListenerit, eli listenerit, joita kutsutaan juuri ennen kuin haku suoritetaan.
		 * Täällä voidaan vielä vaikuttaa esim. haun parametreihin, tai keskeyttää haku kokonaan
		 * palauttamalla callbackista false.
		 * @param resultIdentifier
		 * @param callback {{ sourceQueryObject: {}, resultIdentifier: {string}, appendResults: {bool}, callback: {function} }}
		 * @constructor
		 */
		this.AddPreQueryListener = function(resultIdentifier, callback) {
			if(preQueryListeners[resultIdentifier] === undefined) {
				preQueryListeners[resultIdentifier] = [];
			}
			preQueryListeners[resultIdentifier].push(callback);
		};

		/**
		 * Poista PreQueryListener.
		 * @param callback
		 * @constructor
		 */
		this.RemovePreQueryListener = function(callback) {
			for(var identifier in preQueryListeners) {
				for(var i = 0; i < preQueryListeners[identifier].length; i++) {
					if(preQueryListeners[identifier][i] == callback) {
						preQueryListeners[identifier].splice(i, 1);
						return;
					}
				}
			}
		};



		/**
		 * Hakuun liittyvät notifikaatiot.
		 * Ehkä huono tapa; tällä pyritään välttämään sekavat eventit, eli saman asian voisi
		 * tehdä $scope.$on(...) ja $rootScope.$broadcast(...) kombolla, mutta se on hieman
		 * sekava tapa ja huonosti backträkättävissä.
		 * @param notification
		 * @param callback
		 * @constructor
		 */
		this.AddNotificationListener = function(notification, callback) {
			if(notificationListeners[notification] === undefined) {
				notificationListeners[notification] = [];
			}
			notificationListeners[notification].push(callback);
		};

		this.SendNotification = function(notification, data) {
			if(notificationListeners[notification]) {
				for(var i = 0; i < notificationListeners[notification].length; i++) {
					notificationListeners[notification][i](data);
				}
			}
		};

		this.RemoveNotificationListener = function(callback) {
			for(var notification in notificationListeners) {
				for(var i = 0; i < notificationListeners[notification].length; i++) {
					if(notificationListeners[notification][i] == callback) {
						notificationListeners[notification].splice(i, 1);
						return;
					}
				}
			}
		};

		/**
		 * Sisäinen funktio, ajaa itse API-kutsun.
		 * @param sourceQueryObject
		 * @param resultIdentifier
		 * @param appendResults
		 * @param callback
		 * @param ignorePreQueryCallbacks
		 */
		function RunApiCall(sourceQueryObject, resultIdentifier, appendResults, callback, ignorePreQueryCallbacks) {

			// Kerätään omaksi objektiksi, koska tämä passataan preQueryListenereille,
			// ja objektina säilyy referenssi, jolloin preQueryListenerin muutokset
			// heijastuvat myös tänne puolelle.
			var paramsObj = {
				sourceQueryObject: sourceQueryObject,
				resultIdentifier: resultIdentifier,
				appendResults: appendResults,
				callback: callback
			};

			if(!ignorePreQueryCallbacks) {
				// PreQueryListenerit, suoritetaan ensin ja jos mikään ei palauta falsea, ajetaan kutsu loppuun.
				if(preQueryListeners[resultIdentifier] !== undefined) {
					for(var n = 0; n < preQueryListeners[resultIdentifier].length; n++) {
						var proceed = preQueryListeners[resultIdentifier][n](paramsObj);
						if(!proceed) {
							return;
						}
					}
				}
			}

			// Serialisoidaan API-muotoon vasta preQueryListenerien käpistelyn jälkeen.
			var query = paramsObj.sourceQueryObject.GetAsAPIQueryObject();

			if(typeof ApartmentSearchModel == 'undefined') {
				ApartmentSearchModel = $injector.get('ApartmentSearchModel');
			}

			// Alustetaan results ja merkataan lataus käyntiin.
			if(ApartmentSearchModel.results[paramsObj.resultIdentifier] === undefined) {
				ApartmentSearchModel.results[paramsObj.resultIdentifier] = {};
			}

			ApartmentSearchModel.results[paramsObj.resultIdentifier].loading = true;

			// Itse API-kutsu.
			$http({
				method: 'GET',
				url: '/api/km/KM',
				params: query
			}).then(function(response, status, headers, config) {
				ApartmentSearchModel.results[paramsObj.resultIdentifier].loading = false;
				if(response.data.success) {
					var modelData = ApartmentSearchModel.results[paramsObj.resultIdentifier];
					if(!appendResults) {
						modelData.data = response.data.data;
					}
					else {
						// Appendataan tyhjään resultsettiin, joten käytännössä sama kuin ei appendattaisi...
						if(modelData.data === undefined) {
							modelData.data = response.data.data;
						}
						else {
							for(var i = 0; i < response.data.data.results.length; i++) {
								modelData.data.results.push(response.data.data.results[i]);
							}
						}

					}

					if(typeof paramsObj.callback == 'function') {
						paramsObj.callback(true, paramsObj.resultIdentifier);
					}
					if(queryListeners[paramsObj.resultIdentifier] !== undefined) {
						for(var n = 0; n < queryListeners[paramsObj.resultIdentifier].length; n++) {
							queryListeners[paramsObj.resultIdentifier][n]();
						}
					}
				}
				else {
					console.log("response error:", response);
					if(typeof paramsObj.callback == 'function') {
						paramsObj.callback(false, paramsObj.resultIdentifier);
					}
				}
			}, function(response, status, headers, config) {
				ApartmentSearchModel.results[paramsObj.resultIdentifier].loading = false;
				console.log("error", status, response);
				if(typeof paramsObj.callback == 'function') {
					paramsObj.callback(false, paramsObj.resultIdentifier);
				}
			});
		}

		/**
		 * Saves apartment searches into local storage
		 * @param searchData
		 */
		 this.SaveSearchHistory = function(searchData) {
		 	var history =  this.GetSearchHistory();

			history.unshift(searchData);
			this.searchHistory = history.slice(0, 5);
			BrowserStorageService.LocalStorage.SetItem("ApartmentSearchHistory", this.searchHistory);
			$rootScope.$emit('searchHistoryChanged');
		 };

		 /**
		  * Get saved apartment search history
		  */
		this.GetSearchHistory = function() {
			var searchHistory = BrowserStorageService.LocalStorage.GetItem("ApartmentSearchHistory") || [];
			var searchModel = '';//$injector.get('ApartmentSearchModel');
			var queryVersion = 7;//searchModel.query.GetQueryVersion();
			var history = [];

			for (var i = 0, max = searchHistory.length; i < max; i++) {
				if (searchHistory[i].queryVersion == queryVersion) {
					history.push(searchHistory[i]);
				}
			}

			return history;
		};

		this.searchHistory = [];
		this.searchHistory = this.GetSearchHistory();

		return this;
	}]
);